import { render, staticRenderFns } from "./RenderPostManager.vue?vue&type=template&id=f2877cb2&scoped=true"
import script from "./RenderPostManager.vue?vue&type=script&lang=js"
export * from "./RenderPostManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2877cb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2877cb2')) {
      api.createRecord('f2877cb2', component.options)
    } else {
      api.reload('f2877cb2', component.options)
    }
    module.hot.accept("./RenderPostManager.vue?vue&type=template&id=f2877cb2&scoped=true", function () {
      api.rerender('f2877cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/RenderPostManager.vue"
export default component.exports